<template>
  <div>
    <div class="main-content">
      <div class="section__content section__content--p30">
        <div class="container-fluid">
          <v-card max-width="1024" class="p-b-15 m-b-40">
            <v-card-title class="headline">
              <v-btn
                text icon
                class="m-0"
                @click="$router.back()">
                <i class="zmdi zmdi-long-arrow-left"></i>
              </v-btn>
              {{ text('edit_profile_header') }}
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model.trim="form.name"
                :label="text('enter_name')"
                counter="512">
              </v-text-field>
              <v-text-field
                v-model.trim="form.company"
                :label="text('enter_company')"
                counter="512">
              </v-text-field>
            </v-card-text>
            <v-card-actions class="text-right m-r-10">
              <v-spacer/>
              <v-btn
                color="success"
                @click="onSubmit">
                {{ text('save_changes') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        company: '',
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.user || {};
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  created() {
    this.form.name = this.user.name;
    this.form.company = this.user.company;
  },
  methods: {
    onSubmit() {
      const formData = {
        name: this.form.name,
        company: this.form.company,
      };
      this.$store.dispatch('updateUser', formData)
        .then(() => {
          this.$toasted.success(this.text('profile_popup_success'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.$router.push({ name: 'ProfileInfoPage' });
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
